<template>
  <div>
    <PageHeader class="main">
      <template #title-header-content>
        <div class="flex w-full">
          <div class="font-bold text-white whitespace-nowrap self-center">{{ val.nameSite1 }}</div>
          <div v-if="val.nameSite2" class="font-bold text-white ml-2 whitespace-nowrap self-center">{{ val.nameSite2 }}</div>

          <div v-if="loading" class="animate-pulse text-gray-100 font-bold w-fit pl-5 mx-auto self-center">
            データ取得中...
          </div>

          <div class="w-fit ml-auto flex">
            <!-- 保存 -->
            <PrimaryButton text="保存" class="w-60 mr-10 bg-green-600 border-teal-100 border-2" @click="save()" />

            <div class="mr-2 w-fit">
              <!-- 閉じる -->
              <SecondaryButton
                text="閉じる"
                class="w-24"
                @click="closed()"
              ></SecondaryButton>
            </div>
          </div>
        </div>
      </template>
      <template #page-header-content>
        <div class="text-light-blue-50 font-bold animate-pulse whitespace-nowra -mt-2">
          ※添付資料は即時保存します。それ以外は「保存」ボタンを押してください。
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-28 main w-full bottom-4 -mt-2 leading-8">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full w-full">
        <div class="flex">
          <div v-for="(t, i) in tabs" :key="'t'+i"
            @click="clickTab(t.key)"
            class="mr-4 w-32 py-1 border border-b-0 text-center border-white rounded-t font-bold cursor-pointer"
            :class="tab==t.key?'bg-white text-light-blue-800':'text-light-blue-50 '"
          >
            {{ t.val }}
          </div>
          <div class="ml-8 font-bold text-gray-50 cursor-pointer self-center" @click="allOpen()">
            <span class="border-b border-gray-50 px-2">全て開く</span>
          </div>
          <div class="ml-5 font-bold text-gray-50 cursor-pointer self-center" @click="allClose()">
            <span class="border-b border-gray-50 px-2">全て閉じる</span>
          </div>
        </div>

        <div class="bg-white overflow-auto text-sm main2 w-full">
          <div v-for="(row, i) in items" :key="i" class="w-full">
            <div v-if="row.tab.includes(tab)||tab==0" class="border shadow-lg border-gray-300 rounded p-2 my-5 bg-gray-100 w-full">
              <div class="font-bold text-light-blue-700 mb-2 cursor-pointer flex" @click="clickOpen(row)">
                <div class="w-24 whitespace-pre-line">{{ row.name }}</div>
                <span v-if="row.open">▼</span>
                <span v-else>▶</span>
              </div>

              <!-- 物件情報 -->
              <div v-if="row.name=='基本情報' && row.open" class="grid grid-cols-3 gap-2 item">
                <div>
                  <div class="text-xs font-bold text-gray-700 mb-1">物件コード</div>
                  <div class="font-bold text-indigo-700 mb-3 ml-3">{{ val.siteCode }}</div>
                </div>

                <div>
                  <div class="text-xs font-bold text-gray-700 mb-1">得意先</div>
                  <div class="font-bold text-indigo-700 mb-1 ml-3">{{ val.client1 }}</div>
                  <div class="font-bold text-indigo-700 mb-3 ml-3">{{ val.client2 }}</div>
                </div>

                <div>
                  <div class="text-xs font-bold text-gray-600 mb-1">物件住所</div>
                  <div class="text-sm font-bold text-indigo-700 ml-3">{{ val.address1 }}</div>
                  <div class="text-sm font-bold text-indigo-700 mb-3 ml-3">{{ val.address2 }}</div>
                </div>
              </div>

              <!-- 物件詳細画像 -->
              <div v-if="row.name=='詳細写真' && row.open" class="item">

                <div class="flex gap-2">
                  <div v-if="!photoPdfUrl&&!photoPDFEdit" class="text-xs text-gray-700 flex-1">PDF未作成</div>
                  <div v-else-if="photoPdfUrl" class="flex-1">
                    <a
                      :href="photoPdfUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="font-bold underline text-indigo-800 text-base flex-1"
                    >
                      PDFを開く
                    </a>
                  </div>
                  <PrimaryButton text="再取得" :buttonContents="'要'" class="bg-indigo-100 border-indigo-800 text-indigo-800 border-2 mb-2 w-1/3 ml-auto" @click="getPhotoPdf()" >
                    <Icon slot="before" iconName="Refresh" iconType="solid" :strokeWidth="2" class="h-5 w-5" />
                  </PrimaryButton>

                  <PrimaryButton text="編集" :buttonContents="'要'" class="mb-2 w-1/3" @click="editPhoto()">
                    <Icon slot="before" iconName="PencilAlt" iconType="solid" :strokeWidth="2" class="text-white h-5 w-5" />
                  </PrimaryButton>
                </div>

                <div v-if="photoPdfUrl&&!isSafari">
                  <iframe
                    :src="photoPdfUrl"
                    class="pdf-frame"
                  ></iframe>
                </div>
                <div v-else-if="photoPDFEdit" class="text-gray-700 font-bold animate-pulse m-2">
                  PDFを編集した場合は、1～2分 おいてPDFを再取得してください。
                </div>

                
                <div v-if="isSafari" class="text-gray-700 font-bold animate-pulse m-2">
                  safariでは「PDFを開く」でご確認ください。
                </div>

              </div>

              <div v-if="row.open" class="grid grid-cols-2 gap-2">
                <div v-for="(item, j) in row.items" :key="'i'+j" :class="item.fullwidth?'col-span-2':''">
                  <!-- 文字 -->
                  <div v-if="item.type==='text'" class="item">
                    <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}</div>
                    <input
                      type="text"
                      class="border-gray-300 rounded w-full text-sm"
                      v-model="val[item.key]"
                    />
                  </div>

                  <!-- 数値 -->
                  <div v-else-if="item.type==='number'" class="item">
                    <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}</div>
                    <input
                      type="number"
                      class="border-gray-300 rounded w-full py-1.5"
                      v-model="val[item.key]"
                      @change="validate(item.key)"
                      @wheel="$event.target.blur()"
                    />
                  </div>

                  <!-- TEL -->
                  <div v-else-if="item.type==='tel'" class="item">
                    <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}</div>
                    <input
                      type="tel"
                      class="border-gray-300 rounded w-full"
                      v-model="val[item.key]"
                    />
                  </div>

                  <!-- 文字textarea -->
                  <div v-else-if="item.type==='textarea'" class="item">

                    <!-- 人工 -->
                    <div v-if="item.key=='people'" class="mb-1">
                      <div class="text-xs font-bold text-gray-600 mb-1">＊今後計算に使用するため、標準人工を記入してください（数字のみ可）＊</div>
                      <div class="flex gap-2 items-end">
                        <input
                          type="number"
                          class="border-gray-300 rounded w-full py-1.5"
                          v-model="val.fixedPeople"
                        />
                        <div class="text-sm font-bold text-gray-600 whitespace-nowrap">人工</div>
                        <input
                          type="number"
                          class="border-gray-300 rounded w-full py-1.5 ml-5"
                          v-model="val.fixedHours"
                        />
                        <div class="text-sm font-bold text-gray-600 whitespace-nowrap">時間</div>
                      </div>
                    </div>

                    <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}<span class="pl-5" v-if="item.sms"><span class="sms">SMS</span></span></div>
                    <textarea
                      :rows="2"
                      class="border-gray-300 rounded w-full text-sm"
                      v-model="val[item.key]"
                    ></textarea>
                    <div v-if="val[item.key]&&val[item.key].indexOf('https://') > -1">
                      <div v-for="(link, linkIdx) in textLinks(val[item.key])" v-bind:key="'i'+'l'+j+linkIdx" class="ml-2 mt-1">
                        <a :href="link" target="_blank" rel="noopener noreferrer" class="text-xs text-indigo-600 hover:text-indigo-900 border-b border-indigo-600">{{ link }}</a>
                      </div>
                    </div>
                  </div>

                  <!-- 有無選択 -->
                  <div v-else-if="item.type==='yesno'" class="item">
                    <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}<span class="pl-5" v-if="item.sms"><span class="sms">SMS</span></span></div>
                    <div class="flex text-white font-bold text-base">
                      <div class="rounded-l mx-0.5 w-full text-center px-3 py-1.5 cursor-pointer" :class="val[item.key]?'bg-blue-800':'bg-gray-300'" @click="clickBtn(true, item.key)">{{ item.text1 || '有' }}</div>
                      <div class="rounded-r mx-0.5 w-full text-center px-3 py-1.5 cursor-pointer" :class="val[item.key]===false?'bg-blue-800':'bg-gray-300'" @click="clickBtn(false, item.key)">{{ item.text2 || '無' }}</div>
                    </div>
                  </div>

                  <!-- 表 -->
                  <div v-else-if="item.type==='table'" class="item col-span-2">
                    <div class="flex items-end">
                      <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}</div>
                      <div class="w-20 cursor-pointer ml-auto" @click="addTable(item)"><Icon iconName="PlusCircle" slot="before" class="text-blue-700 h-7 w-7 m-auto" /></div>
                    </div>

                    <table class="w-full">
                      <thead class="bg-blue-100 text-xs text-gray-600">
                        <tr>
                          <th class="p-2 w-36 border-t border-l border-gray-400">記入日</th>
                          <th class="p-2 border-t border-gray-400">内容</th>
                          <th class="w-20 border-t border-r border-gray-400"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(td, ti) in val[item.key] || []" :key="j+'td'+ti" class="border-b text-gray-700 border border-gray-400">
                          <td class="w-16 text-center">
                            <input
                              type="date"
                              class="border-gray-300 rounded w-full text-sm my-1"
                              v-model="td.day"
                            />
                          </td>
                          <td>
                            <textarea
                              :rows="1"
                              class="border-gray-300 rounded w-full text-sm mt-1"
                              v-model="td.note"
                            ></textarea>
                          </td>
                          <td class="text-blue-700 font-bold text-center cursor-pointer" @click="deleteTable(item, ti)">削除</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- 契約詳細情報 -->
                  <div v-else-if="item.type==='contract'" class="item">
                    <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}</div>
                    <div v-if="contract&&contract.length" class="flex flex-wrap gap-3" :class="item.name.indexOf('勤務時間')>-1?'justify-between':''">
                      <div v-for="(c, ci) in contract" :key="j +'c'+ci" class="text-indigo-700 font-bold mb-2" :class="item.name.indexOf('勤務時間')>-1?'contract-form':''">
                        <div v-if="item.name.indexOf('勤務時間')>-1" class="">
                          <div class="bg-blue-700 py-1 px-3 text-white">契約コード：{{ c.cdContract }}<span class="pl-10">{{ c.nameContentsWork }}<span class="font-normal">（{{ c.cdContentsWork }}）</span></span></div>
                          <div class="flex flex-wrap text-sm">
                            <div class="cont">
                              <div class="whitespace-nowrap">祝日勤務</div>
                              <div>{{ c.holiday }}</div>
                            </div>
                            <div class="cont">
                              <div class="whitespace-nowrap">全社休日出勤</div>
                              <div>{{ c.companysHoliday }}</div>
                            </div>
                            <div class="cont">
                              <div class="whitespace-nowrap">時間指定</div>
                              <div>{{ c.specificTime }}</div>
                            </div>
                            <div class="cont">
                              <div>月額</div>
                              <div>{{ formatMoney(c.monthlyFee) }} 円</div>
                            </div>
                            <div class="cont">
                              <div>月時間</div>
                              <div>{{ c.monthlyHours }} ｈ</div>
                            </div>
                            <div class="cont">
                              <div>時給単価</div>
                              <div>{{ formatMoney(c.hourlyWage) }} 円</div>
                            </div>
                          </div>

                          <div class="flex flex-wrap text-sm">
                            <div class="week">
                              <div class="mb-1">月</div>
                              <div>{{ c.startMonday }} - {{ c.endMonday }}</div>
                              <div class="my-1" v-if="Number(c.workingHoursMonday)">{{ c.workingHoursMonday }} h</div>
                              <div>{{c.mon}}</div>
                            </div>
                            <div class="week">
                              <div class="mb-1">火</div>
                              <div>{{ c.startTuesday }} - {{ c.endTuesday }}</div>
                              <div class="my-1" v-if="Number(c.workingHoursTuesday)">{{ c.workingHoursTuesday }} h</div>
                              <div>{{c.tue}}</div>
                            </div>
                            <div class="week">
                              <div class="mb-1">水</div>
                              <div>{{ c.startWednesday }} - {{ c.endWednesday }}</div>
                              <div class="my-1" v-if="Number(c.workingHoursWednesday)">{{ c.workingHoursWednesday }} h</div>
                              <div>{{c.wed}}</div>
                            </div>
                            <div class="week">
                              <div class="mb-1">木</div>
                              <div>{{ c.startThursday }} - {{ c.endThursday }}</div>
                              <div class="my-1" v-if="Number(c.workingHoursThursday)">{{ c.workingHoursThursday }} h</div>
                              <div>{{c.thu}}</div>
                            </div>
                            <div class="week">
                              <div class="mb-1">金</div>
                              <div>{{ c.startFriday }} - {{ c.endFriday }}</div>
                              <div class="my-1" v-if="Number(c.workingHoursFriday)">{{ c.workingHoursFriday }} h</div>
                              <div>{{c.fri}}</div>
                            </div>
                            <div class="week">
                              <div class="mb-1">土</div>
                              <div>{{ c.startSaturday }} - {{ c.endSaturday }}</div>
                              <div class="my-1" v-if="Number(c.workingHoursSaturday)">{{ c.workingHoursSaturday }} h</div>
                              <div>{{c.sat}}</div>
                            </div>
                            <div class="week">
                              <div class="mb-1">日</div>
                              <div>{{ c.startSunday }} - {{ c.endSunday }}</div>
                              <div class="my-1" v-if="Number(c.workingHoursSunday)">{{ c.workingHoursSunday }} h</div>
                              <div>{{c.sun}}</div>
                            </div>
                          </div>
                        </div>

                        <div v-if="item.name.indexOf('ゴミ')>-1" class="flex whitespace-nowrap">
                          <div>【契約コード：{{ c.cdContract }}】</div>
                          <div>{{ c.trash }}</div>
                        </div>

                        <div v-else-if="item.name.indexOf('祝日勤務')>-1" class="flex whitespace-nowrap">
                          <div>【契約コード：{{ c.cdContract }}】</div>
                          <div>{{ c.holiday }}</div>
                          <div>（全社休日出勤：{{ c.companysHoliday }}）</div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="text-xs text-gray-700 ml-3 my-4">該当データなし</div>
                  </div>

                  <!-- ビルメン情報 -->
                  <div v-else-if="item.type==='billmen'" class="item">
                    <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}</div>
                    <div v-if="billmen&&billmen.length">
                      <table class="w-full text-xs">
                        <thead class="bg-blue-100 text-gray-700 border border-gray-400">
                          <tr>
                            <th class="p-2">区分</th>
                            <th class="p-2 border border-dashed border-gray-400">作業名</th>
                            <th class="p-2 border border-dashed border-gray-400">作業部門</th>
                            <th class="p-2 text-sm border border-dashed border-gray-400" v-for="(m) in [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2]" :key="'m' + m">
                              {{ m }} 月
                            </th>
                            <th class="p-2">合計</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(td, ti) in billmen || []" :key="j+'f'+ti" class="border border-gray-400">
                            <td class="p-2 font-bold text-indigo-800">
                              {{ td.kubun }}
                            </td>
                            <td class="p-2 font-bold text-indigo-700 border border-dashed border-gray-400">
                              {{ td.name }}
                            </td>
                            <td class="p-2 font-bold text-gray-700 border border-dashed border-gray-400">
                              {{ td.dep }}
                            </td>
                            <td class="text-center p-2 border border-dashed border-gray-400 text-gray-700" v-for="(w) in [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2]" :key="ti + 'w' + w" :class="td['work'+w]||td['fee'+w]!='0'?'bg-yellow-200':''">
                              <div v-if="td['work'+w]" class="text-gray-600">作業月</div>
                              <div v-if="td['fee'+w]!='0'" class="text-sm">{{ td['fee'+w] }}</div>
                            </td>
                            <td class="text-center p-2 font-bold text-gray-600">
                              <div v-if="td.totalFee!='0'">{{ td.totalFee }}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="text-xs text-gray-700 ml-3 my-4">該当データなし</div>
                  </div>

                  <!-- 定期清掃ビルメン情報 -->
                  <div v-else-if="item.type==='fixed'" class="item">
                    <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}</div>
                    <div v-if="fixed&&fixed.length">
                      <table class="w-full text-xs">
                        <thead class="bg-blue-100 text-gray-700 border border-gray-400">
                          <tr>
                            <th class="p-2">作業名</th>
                            <th class="p-2 border border-dashed border-gray-400">作業部門</th>
                            <th class="p-2 text-sm border border-dashed border-gray-400" v-for="(m) in [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2]" :key="'m' + m">
                              {{ m }} 月
                            </th>
                            <th class="p-2">合計</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(td, ti) in fixed || []" :key="j+'f'+ti" class="border border-gray-400">
                            <td class="p-2 font-bold text-indigo-700">
                              {{ td.name }}
                            </td>
                            <td class="p-2 font-bold text-gray-700 border border-dashed border-gray-400">
                              {{ td.dep }}
                            </td>
                            <td class="text-center p-2 border border-dashed border-gray-400 text-gray-700" v-for="(w) in [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2]" :key="ti + 'w' + w" :class="td['work'+w]?'bg-yellow-200':''">
                              <div v-if="td['work'+w]" class="text-gray-600">作業月</div>
                              <div v-if="td['fee'+w]!='0'" class="text-sm">{{ td['fee'+w] }}</div>
                            </td>
                            <td class="text-center p-2 font-bold text-gray-600">
                              {{ td.totalFee }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="text-xs text-gray-700 ml-3 my-4">該当データなし</div>
                  </div>

                  <!-- 契約書 -->
                  <div v-else-if="item.type==='contractLinks'" class="item bg-yellow-50 p-2">
                    <div class="text-xs font-bold text-yellow-700 mb-1 flex">
                      <div class="self-end">契約書URL</div>
                      <!-- 追加 -->
                      <div @click="val.contractLinks.push('')" class=" w-fit px-2 cursor-pointer">
                        <PlusCircleIcon class="text-yellow-600 hover:text-yellow-700 active:text-yellow-800 w-6 h-6" />
                      </div>
                    </div>
                    <div v-for="(c, i) in val.contractLinks" :key="'cl'+i" class="mb-3">
                      <div class="flex">
                        <input
                          type="text"
                          class="rounded border-gray-300 text-xs text-gray-700 w-full"
                          v-model="val.contractLinks[i]"
                        />
                        <!-- 削除 -->
                        <div @click="deleteArray('contractLinks', i)" class="ml-auto w-fit py-1 px-2 cursor-pointer">
                          <TrashIcon class="text-gray-400 hover:text-gray-500 active:text-gray-600 w-5 h-5" />
                        </div>
                      </div>

                      <!-- ハイパーリンク -->
                      <div class="ml-3">
                        <a :href="c" target="_blank" class="text-indigo-600 hover:text-indigo-900 border-b border-indigo-600 text-xs">{{ c }}</a>
                      </div>
                    </div>
                  </div>

                  <!-- URL -->
                  <div v-else-if="item.type=='url'" class="item">
                    <div v-if="item.name.indexOf('RLSマスタ') > -1">
                      <div v-if="isRls">
                        <div class="w-fit px-2 border-b border-blue-700 font-bold text-blue-700 text-sm cursor-pointer" @click="clickUrl(item)">{{ item.name }}を開く</div>
                      </div>
                      <div v-else class="text-xs text-gray-700 ml-3 my-4">
                        RLS該当なし
                      </div>
                    </div>
                    <div v-else-if="item.url=='patrolURL'">
                      <div v-if="patrolURL" class="w-fit px-2 border-b border-blue-700 font-bold text-blue-700 text-sm cursor-pointer" @click="clickUrl(item)">{{ item.name }}を開く</div>
                      <div v-else class="text-xs text-gray-700 ml-3 my-4">
                        {{ item.name }} なし
                      </div>
                    </div>
                  </div>

                  <!-- 行調整 -->
                  <div v-else-if="!item.type"></div>

                  <!-- 添付 -->
                  <div v-if="item.type==='attach'" class="item">
                    <div class="text-xs font-bold text-gray-600 mb-1">{{ item.name }}<span class="pl-5" v-if="item.sms"><span class="sms">SMS</span></span></div>

                    <div class="flex">
                      <textarea
                        v-if="item.noteKey"
                        :rows="2"
                        class="border-gray-300 rounded w-full text-sm mr-2"
                        v-model="val[item.noteKey]"
                      ></textarea>
                      <div class="text-xs font-bold text-gray-600 flex file-btn w-fit" v-tooltip="'このボタンの上にファイルをドロップしても添付できます'">
                        <input class="file-type" type="file" @change="fileToBase64($event, item.key)" multiple />
                        <PrimaryButton :text="loading?'Loading...':'添付'" size="sm" class="bg-blue-400 whitespace-nowrap px-5" :class="loading?'animate-pulse cursor-not-allowed':''" :disabled="loading" />
                      </div>
                    </div>

                    <div class="flex flex-wrap rounded text-sm">
                      <div v-if="!loading&&(!attach[item.key]||!attach[item.key].length)" class="text-xs text-gray-700 ml-3 my-4">添付なし</div>

                      <!-- 添付ありの場合 -->
                      <div v-for="(at, atIdx) in attach[item.key] || []" :key="item.type+atIdx" class="my-2 border border-gray-300 rounded" :class="item.fullwidth?'w-1/6':'w-1/3'">

                        <!-- <div v-if="isImage(at)" class="text-xs text-blue-700 cursor-pointer w-fit border-b border-blue-700 ml-2 mb-1" @click="getBigImg(at, at.type+atIdx)">
                          もとの大きさの画像を取得
                        </div>
                        <div v-else class="h-4"></div> -->

                        <!-- S3保存 -->
                        <div v-if="isS3Saved(at)">
                          <!-- 画像 -->
                          <div v-if="isImage(at)">
                            <a :id="at.type+atIdx" :href="at.s3Url" :data-lightbox="at.type">
                              <img :src="at.s3Url" class="object-contain photo">
                            </a>
                            <div class="text-center text-xs font-bold text-gray-600">{{ at.name }}</div>
                          </div>
                          <!-- 画像以外 -->
                          <div v-else @click="openFile(at)" class="text-center p-2 cursor-pointer photo">
                            <div class="">
                              <Icon iconName="Document" :strokeWidth="2" class="h-8 w-8 m-auto" />
                              <p class="font-bold">{{ at.name }}</p>
                            </div>
                          </div>
                        </div>

                        <!-- サイボウズに保存（過去データ） -->
                        <div v-else-if="at" class="photo p-2 text-center truncate">
                          <div>
                            サイボウズ：{{ at.name }}
                            <p class="text-xs text-gray-600 mt-1">（システムに保存されていません）</p>
                          </div>
                        </div>

                        <!-- 削除 -->
                        <div @click="deleteAttach(at, item.key, atIdx)" class="ml-auto w-fit py-1 px-2 cursor-pointer">
                          <TrashIcon class="text-gray-400 hover:text-gray-500 active:text-gray-600 w-5 h-5" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-transparent text-xs">{{reload}}</div>
        </div>
      </div>
    </main>
    <!-- RLSマスタモーダル -->
    <RlsMstEditModal
      v-model="modalOpen"
      :target="modalData"
      :staffList="staffList"
      :open="modalOpen"
      @closed="modalClosed"
    />
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import { TrashIcon, PlusCircleIcon } from '@vue-hero-icons/solid'
import RlsMstEditModal from '../../Rls/components/RlsMstEditModal.vue'
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'
import * as dialogs from '@libs/dialogs'
import * as moment from 'moment'
// import * as image from '@libs/image'
import PageModel from '../../main/pages/PageModel.vue'
const SETTION_STRAGE_NAME_staffList = 'rlsStaffList'

// 基本情報
const info = { name: '基本情報', tab: [1, 3, 4], open: true, items: [
  { key: 'clientPic', name: 'ご担当者様', type: 'text' },

  { key: 'stairs', name: '階数', type: 'number' },
  { key: 'household', name: '世帯数', type: 'number' },
  { key: 'tenant', name: 'テナント数', type: 'number' },

  { key: 'householdNote', name: '階数・世帯数・テナント数 備考', type: 'textarea' },
]}

// トイレ・EV
const toilet = { name: 'トイレ・EV', tab: [1, 3, 4], open: true, items: [
  { key: 'isToilet', name: 'トイレ有無', type: 'yesno' },
  { key: 'toiletNote', name: 'トイレ備考', type: 'textarea' },

  { key: 'isEv', name: 'エレベーター有無', type: 'yesno' },
  { key: 'evNote', name: 'エレベーター備考', type: 'textarea' },
]}

// 契約書
const contract = { name: '契約書・平面図', tab: [1, 3, 4], open: true, items: [
  { key: 'contractAttach', name: '契約書', type: 'attach', noteKey: 'contractNote' },
  { name: '契約書URL', type: 'contractLinks' },

  { key: 'floorPlanAttach', name: '物件平面図', type: 'attach', noteKey: 'floorPlan' },
  { key: 'fileAttach', name: 'その他、添付ファイル', type: 'attach', noteKey: 'fileNote' },

  { name: '作業明細（ビルメンより契約中の情報）＊金額は受注金額です', type: 'billmen', fullwidth: true },
]}

// 管理員
const mng = { name: '管理員・室', tab: [1, 3, 4], open: true, items: [
  { key: 'isApartmentManager', name: '管理「員」有無', type: 'yesno' },
  { key: 'isApartmentManagerRoom', name: '管理「室」有無', type: 'yesno' },
  { key: 'apartmentManagerTel', name: '管理室TEL', type: 'tel' },
  { key: 'apartmentManagerFax', name: '管理室FAX', type: 'tel' },
]}

// 鍵
const key = { name: '鍵', tab: [1, 3, 4], open: true, items: [
  { key: 'isAutoLock', name: 'オートロック有無', type: 'yesno' },
  { key: 'autoLockNote', name: 'オートロック備考', type: 'textarea', sms: true },

  { key: 'keyBox', name: 'キーBOX番号', type: 'textarea', sms: true },

  { key: 'keyBoxAttach', name: 'キーBOX場所', type: 'attach', noteKey: 'keyBoxLocation', sms: true },

  { type: '' },

  { key: 'isHotelLock', name: 'ホテル錠有無', type: 'yesno' },
  { key: 'hotelLockNote', name: 'ホテル錠備考', type: 'textarea' },
]}

// 警報・警備
const alarm = { name: '警報・警備', tab: [1, 3, 4], open: true, items: [
  { key: 'isAlarm', name: '警報有無', type: 'yesno', sms: true },
  { key: 'alarmNote', name: '警報備考', type: 'textarea' },

  { key: 'alarmCancelAttach', name: '警備解除方法', type: 'attach', noteKey: 'alarmCancel' },

  { key: 'mgmtRoomAttach', name: '警備管理室', type: 'attach', noteKey: 'mgmtRoom' },
  { key: 'alarmCancelPanelAttach', name: '警備解除操作盤', type: 'attach', noteKey: 'alarmCancelPanel' },

  { key: 'isSecurityCamera', name: '防犯カメラ有無', type: 'yesno' },
]}

// 用具
const tools = { name: '用具', tab: [1], open: true, items: [
  { key: 'cleaningToolsCarry', name: '用具搬入', type: 'textarea' },
  { key: 'cleaningToolsAttach', name: '用具置場', type: 'attach', noteKey: 'cleaningTools', sms: true },
]}

// 車
const car = { name: '車・交通', tab: [1, 4], open: true, items: [
  { key: 'traffic', name: '交通情報', type: 'text' },
  { key: 'parkingAttach', name: '駐車位置', type: 'attach', noteKey: 'parking' },
]}

// 二輪車
const bike = { name: '二輪車', tab: [1], open: true, items: [
  { key: 'bikeAttach', name: 'バイク駐車位置', type: 'attach', noteKey: 'bikeNote' },
  { type: '' },

  { key: 'isBicycle', name: '自転車通勤可否', type: 'yesno' },
  { key: 'bicycleNote', name: '自転車通勤備考', type: 'textarea' },
]}

// ゴミ
const trash = { name: 'ゴミ', tab: [2], open: true, items: [
  { url: '', name: 'RLSマスタ', type: 'url' },
  { key: 'trashAttach', name: 'ゴミ置場', type: 'attach', noteKey: 'trashNote', sms: true },

  { name: 'ゴミ搬出有無 （契約詳細情報より）', type: 'contract' },
  { key: 'trashCarryingNote1', name: 'ゴミ搬出場所説明', type: 'textarea', sms: true },

  { key: 'trashCarryingAttach', name: 'ゴミ搬出', type: 'attach', noteKey: 'trashCarryingNote2' },
  { key: 'trashWeek', name: 'ゴミ収集曜日', type: 'textarea' },

  { key: 'isTrashNet', name: 'ゴミネット回収有無', type: 'yesno' },
  { key: 'trashNetNote', name: 'ゴミネット回収備考', type: 'textarea' },

]}

// メモ
const memo = { name: 'MEMO', tab: [1], open: true, items: [
  { key: 'requiredInfo', name: '必須伝達事項', type: 'textarea' },
  // 最寄り駅と徒歩は AKBS の欠員募集でも表示・登録する
  { key: 'nearestStation', name: '最寄り駅', type: 'text' },
  { key: 'walkMinutes', name: '最寄り駅から徒歩（分）', type: 'number' },
  { key: 'route', name: '道順', type: 'textarea' },

  { key: 'dangerAttach', name: '危険個所', type: 'attach', noteKey: 'danger' },

  { key: 'fixedCleanNote', name: '定期清掃物件概要メモ', type: 'textarea' },
  { key: 'note', name: '備考', type: 'textarea' },
]}

// その他
const other = { name: 'その他', tab: [1], open: true, items: [
  { key: 'isReport', name: '指定報告書', type: 'yesno' },
  { key: 'reportNote', name: '指定報告書置き場', type: 'textarea', sms: true },

  { key: 'mailBox', name: 'メールBOX番号', type: 'textarea', sms: true },
  { key: 'enter', name: '入り', type: 'textarea' },

  { key: 'isComplete', name: '完了チェック', type: 'yesno', text1: '完了済', text2: '未完了' },
]}

// 日常
const daily = { name: '日常・管理', tab: [3], open: true, items: [
  { name: '勤務時間 （契約詳細情報より）', type: 'contract', fullwidth: true },
  { url: 'patrolURL', name: '品質巡回報告書（最新のもの）', type: 'url' },
  { key: 'hoursNote', name: '契約時間備考', type: 'textarea' },

  { name: '祝日勤務 （契約詳細情報より）', type: 'contract' },
  { key: 'holidayNote', name: '祝日勤務備考', type: 'textarea' },

  { key: 'attention', name: '注意事項', type: 'textarea', sms: true },
  { key: 'insteadHistory', name: '代勤履歴', type: 'textarea' },

  { key: 'attendTelAttach', name: '勤怠電話設置場所', type: 'attach', noteKey: 'attendTelNote' },
  { key: 'dailyReportAttach', name: '日常報告書', type: 'attach', noteKey: 'dailyReportNote' },

  { key: 'handoverAttach', name: '引き継ぎ書', type: 'attach' },
  { key: 'attendNote', name: '勤怠管理課メモ', type: 'textarea' },

]}

// 日常（曜日備考）
const weekNote = { name: '日常・管理\r\n(曜日備考)', tab: [3], open: true, items: [
  { key: 'monday', name: '月曜勤務に関するメモ', type: 'textarea' },
  { key: 'tuesday', name: '火曜勤務に関するメモ', type: 'textarea' },

  { key: 'wednesday', name: '水曜勤務に関するメモ', type: 'textarea' },
  { key: 'thursday', name: '木曜勤務に関するメモ', type: 'textarea' },

  { key: 'friday', name: '金曜勤務に関するメモ', type: 'textarea' },
  { key: 'saturday', name: '土曜勤務に関するメモ', type: 'textarea' },

  { key: 'sunday', name: '日曜勤務に関するメモ', type: 'textarea' },
]}

// 定期
const fixed = { name: '定期清掃', tab: [4], open: true, items: [
  { name: '定期清掃契約（ビルメンより契約中の情報）＊金額は受注金額です', type: 'fixed', fullwidth: true },

  { key: 'people',  name: '人工備考', type: 'textarea' },
  { key: 'cleanser', name: '洗剤', type: 'text' },

  { key: 'wax', name: 'ワックス', type: 'text' },
  { key: 'peeling', name: '剥離', type: 'text' },

  { key: 'rinser', name: 'リンサー', type: 'text' },
  { key: 'poly', name: 'ポリ', type: 'text' },

  { key: 'carpet', name: 'カーペット', type: 'text' },
  { key: 'poster', name: '張り紙情報', type: 'text' },

  { key: 'powerAttach', name: '電源', type: 'attach', noteKey: 'power' },
  { key: 'pressureAttach', name: '高圧', type: 'attach', noteKey: 'pressure' },

  { key: 'waterAttach', name: '水源', type: 'attach', noteKey: 'water' },
  { key: 'generator', name: '発電機', type: 'text' },

  { key: 'engine', name: 'エンジン高圧', type: 'text' },
  { key: 'hose', name: 'ホース', type: 'text' },

  { key: 'bucket', name: 'バケツ', type: 'text' },
  { key: 'equipmentAttach', name: '必須備品・備品置場', type: 'attach', noteKey: 'equipment' },

  { key: 'scatteringAttach', name: '飛散箇所', type: 'attach', noteKey: 'scattering' },
  { key: 'carSheetAttach', name: 'カーシート', type: 'attach', noteKey: 'carSheet' },

  { key: 'fixedCleanNote', name: '定期清掃物件概要メモ', type: 'textarea' },
  { key: 'processAttach', name: '作業行程', type: 'attach', noteKey: 'process', fullwidth: true },

  { key: 'fixedNote', name: '申し送り（注意事項、次回の作業要望など）記入日の降順で表示', type: 'table', fullwidth: true },
  { key: 'fixedPhoto', name: 'その他、定期清掃写真', type: 'attach', fullwidth: true },
]}

// 写真
const photos = { name: '詳細写真', tab: [5], open: true, items: []}

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    PrimaryButton,
    SecondaryButton,
    TrashIcon,
    PlusCircleIcon,
    RlsMstEditModal
  },

  data() {
    return {
      val: {},
      attach: {},
      contract: [],
      // ビルメンの定期清掃
      fixed: [],
      // ビルメン情報
      billmen: [],
      siteCode: null,
      reload: 0,
      loading: false,
      attachLoading: true,
      tabs: [
        { key: 0, val: '全て' },
        { key: 1, val: '物件情報' },
        { key: 2, val: 'ゴミ関連' },
        { key: 3, val: '日常・管理' },
        { key: 4, val: '定期清掃' },
        { key: 5, val: '詳細写真' },
      ],
      tab: 0,

      // RLS対象物件か
      isRls: false,
      // スタッフリスト（RLS実施者）
      staffList: [],
      // RLSマスタモーダル
      modalOpen: false,
      modalData: null,

      // 品質巡回報告書URL
      patrolURL: null,

      // 詳細写真URL
      photoPdfUrl: null,

      // PDF編集を押したか
      photoPDFEdit: false

    }
  },

  created() {
    this.getStaff()
  },

  mounted() {
    this.$nextTick(() => {
      this.getTarget()
      this.getPhotoPdf()
      if (this.$route.query.tab) {
        this.tab = Number(this.$route.query.tab)
        this.clickTab(this.tab)
      }
    })
  },

  computed: {
    /**
     * 保存するのに必要な基本情報
     */
    saveInfo() {
      return {
        siteCode: this.siteCode,
        insertUser: this.$store.getters.user.id,
      }
    },

    /**
     * 3桁区切り
     */
    formatMoney() {
      return(val) => {
        if (val) {
          return (Number(val)).toLocaleString()
        }
        return '-'
      }
    },

    /**
     * 権限
     */
    auth() {
      if (this.$store.getters.auth &&  this.$store.getters.auth.contractAuth) {
        return true
      }
      return false
    },

    /**
     * タブによって表示する項目
     */
    items() {
      return [info, contract, key, alarm, toilet, mng, tools, car, bike, trash, memo, other, daily, weekNote, fixed, photos]
    },

    /**
     * リンク取得
     */
    textLinks() {
      return (val) => {
        if (val) {
          const url = []
          const v = val.split('\n')
          if (v && v.length) {
            for (let i = 0; i < v.length; i++) {
              const txt = v[i]
              let add = ''

              if (txt.indexOf('https://') >= 0) {
                add = txt.substring(txt.indexOf('https://'))
                url.push(add)
              }
            }
          }
          return url
        }
        return []
      }
    },

    /**
     * safari
     */
    isSafari() {
      return utils.deviceInfo.isSafari
    },
  },

  methods: {
    /**
     * 表示するデータ取得
     */
    async getTarget() {
      if (!this.auth) {
        await dialogs.showErrorDialog('権限なしのため表示不可', '契約情報権限がないため、メニュー画面に戻ります。')
        this.$router.push('/')
        return
      }

      this.loading = true
      this.init()
      if (this.$route.query.siteCode) {
        this.siteCode = this.$route.query.siteCode
        // 対象物件の物件概要書取得
        const res = await backend.searchData('siteOutline/getOutline', { siteCode: this.siteCode })
        this.val = res.data.data.info || { contractLinks: [''] }
        this.contract = res.data.data.contract
        this.fixed = res.data.data.fixed
        this.billmen = res.data.data.billmen
        this.isRls = res.data.data.isRls
        const patrolScheduleId = res.data.data.patrolScheduleId

        if (patrolScheduleId) {
          this.patrolURL = `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}CheckListTable?scheduleId=${patrolScheduleId}&open=true`
        } else {
          this.patrolURL = null
        }

        if (!this.val.contractLinks) {
          this.val.contractLinks = ['']
        }
        this.items.forEach(row => {
          row.items.forEach(item => {
            if (item.type === 'table' && (!this.val[item.key] || !this.val[item.key].length)) {
              this.addTable(item)
            }
          })
        })
        await this.getS3Url()
      }
      this.loading = false
    },

    /**
     * S3から期限付きURL取得
     */
    async getS3Url() {
      this.attach = {}
      if (this.siteCode) {
        // 対象物件の物件概要書取得
        const res = await backend.searchData('siteOutline/getS3Url', { siteCode: this.siteCode })
        if (res.data.data) {
          this.attach = res.data.data
        //   for (let i = 0; i < Object.keys(attach).length; i++) {
        //     const row = attach[Object.keys(attach)[i]]
        //     for (let j = 0; j < row.length; j++) {
        //       const r = row[j]
        //       r.base64 = image.bufferToDataUrl(r.base64)
        //     }
        //   }
        //   this.attach = res.data.data
        }
        this.reload++
      }
    },

    /**
     * 物件詳細写真PDFのURL取得
     */
    async getPhotoPdf() {
      if (this.$route.query.siteCode) {
        this.photoPdfUrl = ''
        // 対象物件の物件概要書取得
        const res = await backend.searchData('siteOutline/getPhotoPdf', { siteCode: this.$route.query.siteCode })
        if (res.data.data) {
          this.photoPdfUrl = res.data.data
        }
      }
    },

    /**
     * 有無変更
     * @param e 値
     * @param item 対象プロパティー
     */
    clickBtn(e, item) {
      this.val[item] = e
      this.reload++
    },

    /**
     * 配列から削除
     * @param tar 対象項目プロパティ名
     * @param i インデックス
     */
    deleteArray(tar, i) {
      this.val[tar].splice(i, 1)
      if (!this.val[tar] || !this.val[tar].length) {
        this.val[tar] = ['']
      }
      this.reload++
    },

    /**
     * 少数はNG
     */
    async validate(tar) {
      await utils.wait(100)
      // 少数なら削除
      if (this.val[tar]) {
        if (this.val[tar].includes('.')) {
          this.val[tar] = null
        }
      }
      this.reload++
    },

    /**
     * テーブル追加
     */
    addTable(item) {
      if (!this.val[item.key]) {
        this.val[item.key] = []
      }
      this.val[item.key].push({ day: moment().format('YYYY-MM-DD'), note: '' })
      this.reload++
    },

    /**
     * テーブル削除
     */
    deleteTable(item, i) {
      this.val[item.key].splice(i, 1)
      if (!this.val[item.key] || !this.val[item.key].length) {
        this.addTable(item)
      }
      this.reload++
    },

    /**
     * タブ切り替え
     * @param key
     */
    clickTab(key) {
      if ([3, 4].includes(key)) {
        this.items.forEach(row => {
          if (['日常・管理', '日常・管理\r\n(曜日備考)', '定期清掃'].includes(row.name)) {
            row.open = true
          } else {
            row.open = false
          }
        })
      } else {
        this.items.forEach(row => {
          row.open = true
        })
      }
      this.tab = key
    },

    /**
     * 項目開閉
     * @param row
     */
    clickOpen(row) {
      row.open = !row.open
      this.reload++
    },

    /**
     * 項目全て開く
     */
    allOpen() {
      this.items.forEach(row => {
        row.open = true
      })
      this.reload++
    },

    /**
     * 項目全て閉じる
     */
    allClose() {
      this.items.forEach(row => {
        row.open = false
      })
      this.reload++
    },

    /**
     * 保存
     */
    async save() {
      if (this.val.contractLinks && this.val.contractLinks.length) {
        const links = this.val.contractLinks.filter((c) => {
          return c
        })
        if (links && links.length) {
          this.val.contractLinks = links
        } else {
          this.val.contractLinks = null
        }
      }
      await backend.postData('siteOutline/save', { ...this.val, ...this.saveInfo })
      const res = await dialogs.showConfirmDialog('保存完了', '画面を閉じますか？', '閉じる', '閉じない')
      if (res != 'YES') {
        return
      }
      this.closed()
    },

    /**
     * 初期化
     */
    init() {
      this.val = {}
      this.attach = {}
      this.contract = []
    },

    closed() {
      window.open('','_self').close()
    },

    /**
     * 添付削除
     * @param {*} row 対象データ
     * @param key 対象プロパティ
     */
    async deleteAttach(row, key, i) {
      const log = await dialogs.showWarningConfirmDialog('削除してよろしいでしょうか？', row.name + ' を削除してよろしいでしょうか？')
      if (log != 'YES') {
        return
      }
      await backend.postData('siteOutline/deleteAttach', { id: row.id })
      this.attach[key].splice(i, 1)
    },

    /**
     * S3保存されているか
     */
    isS3Saved(item) {
      if (item && item.url && item.url.includes('outline/')) {
        return true
      }
      return false
    },

    /**
     * 画像判定
     */
    isImage(item) {
      if (item && item.name) {
        return /\.(jpg|jpeg|png|gif|webp)$/i.test(item.name)
      }
      return false
    },

    /**
     * 元の大きさの画像取得
     * @param item 対象添付
     */
    // async getBigImg(item, idName) {
    //   this.loading = true
    //   const res = await backend.searchData('siteOutline/getS3', { url: item.url })
    //   if (res.data.data) {
    //     item.base64 = image.bufferToDataUrl(res.data.data)
    //     this.loading = false
    //     await utils.wait(200)
    //     document.querySelector('#' + idName).click()
    //   }
    //   this.loading = false
    // },

    /**
     * 画像以外のクリックイベント
     */
    async openFile(item) {
      // Excelならダウンロード
      if (item.name.match(/\.(xls|xlsx)$/i)) {
        const a = document.createElement('a')
        a.href = item.s3Url
        a.download = item.name
        a.target = '_blank'
        a.click()
        a.remove()

        // const response = await fetch(item.s3Url)
        // const blob = await response.blob()

        // const url = URL.createObjectURL(blob)

        // const a = document.createElement('a')
        // a.href = url
        // a.download = item.name
        // a.click()

        // URL.revokeObjectURL(url)

      // PDFやWordは別タブで開く
      } else {
        window.open(item.s3Url, '_blank')
      }
    },

    /**
     * 添付Base64に変換
     * @param e 添付データ
     * @param key プロパティー名
     */
    async fileToBase64(e, key) {
      if (!this.attach[key]) {
        this.attach[key] = []
      }
      this.loading = true
      // 選択されたファイルの取得
      const file = e.target.files
      // Base64に変換する
      for (let j = 0; j < file.length; j++) {
        const f = await utils.fileToDataUrl(file[j])
        const tar = { type: key, name: file[j].name, base64: f }
        this.attach[key].push(tar)

        await this.saveFile(tar)
      }
    },

    /**
     * 添付保存
     * @param item 対象データ
     */
    async saveFile(tar) {
      this.loading = true
      const saveData = {
        ...this.saveInfo,
        ...tar
      }
      const res = await backend.postData('siteOutline/saveAttach', saveData)
      if (res.data.data) {
        tar.s3Url = res.data.data.s3Url
        tar.url = res.data.data.url
      }
      this.loading = false
    },

    /**
     * スタッフリスト取得
     */
    async getStaff() {
      const strage = this.getCondition(SETTION_STRAGE_NAME_staffList)
      if (strage && strage.length) {
        this.staffList = strage
      }

      if (!this.staffList || !this.staffList.length) {
        const res = await backend.searchData('user/getByAuth', { auth: 'rls', departmentName: 'ラウンド', departmentName2: '品質管理', departmentName3: '建物管理' })
        if (res && res.data.data && res.data.data.length) {
          this.staffList = res.data.data
          this.setSessionStorage()
        }
      }
    },

    /**
     * URLクリック
     */
    clickUrl(item) {
      if (item.name.indexOf('RLSマスタ') > -1) {
        this.RlsMstOpen()
      } else {
        window.open(this[item.url], '_blank')
      }
    },

    /**
     * 編集ボタン
     */
    RlsMstOpen() {
      this.modalData = { siteCode: this.siteCode }
      this.modalOpen = true
    },

    /**
     * 編集モーダル閉じる
     */
    modalClosed() {
      this.modalOpen = false
    },

    /**
     * 検索条件をセッションストレージへ保存
     */
    setSessionStorage() {
      const searchStr = JSON.stringify(this.staffList)
      sessionStorage.setItem(SETTION_STRAGE_NAME_staffList, searchStr)
    },

    /**
     *  条件取得
     */
    getCondition(name) {
      const searchJson = sessionStorage.getItem(name)
      if (searchJson) {
        return JSON.parse(searchJson)
      }
      return null
    },

    /**
     * 写真PDF編集
     */
    editPhoto() {
      const resolvedRoute = this.$router.resolve({
        name: 'SiteOutlinePhotoEdit',
        query: {
          siteCode: this.siteCode
        }
      })
      window.open(resolvedRoute.href, '_blank')
      this.photoPDFEdit = true
      this.photoPdfUrl = ''
    }
  }
}
</script>
<style scoped>

.main {
  min-width: 1200px;
}

.main2 {
  min-width: 1190px;
  height: calc(100% - 25px);
}


.form1 {
  width: calc(100% - 10px);
}

/* .form {
  width: 100%;
  min-width: 500px;
  padding-bottom: 15px;
} */

.item {
  /* width: 100%; */
  margin: 18px 10px;
}

.cont {
  padding: 8px;
  border: 1px solid blue;
  text-align: center;
  background: azure;
  flex: 1;
}

.week {
  padding: 8px 4px;
  border: 1px solid blue;
  border-radius: 4px;
  margin: 3px;
  text-align: center;
  flex: 1;
}

.sms {
  padding: 2px 4px;
  color: white;
  background: rgb(15, 110, 71);
  font-weight: bold;
  font-size: xx-small;
  border-radius: 10px;
}

textarea {
  field-sizing: content;
}

.tab {
  background-color: rgba(93, 240, 191, 0.644);
}

.photo {
  width: 90%;
  height: 150px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-btn {
  display: inline-block;
  position: relative;
}

_::-webkit-full-page-media,
_:future,
:root .file-btn {
  display: inline-block;
  position: relative;
}

.file-type {
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

_::-webkit-full-page-media,
_:future,
:root .file-type {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  position: absolute;
}

.contract-form {
  width: 48%;
}

.pdf-frame {
  width: 100%;
  height: calc(100vh - 324px);
  border: none;
}

</style>